export default "__VITE_ASSET__BKr_kOg3__"